<template>
  <div>
    <button @click="openDialog"></button>

    <formChangeState :dialog="visible"  :postChangeState="changeStateProps" />


  </div>
</template>

<script>
import formChangeState from './components/form_detail_change_state_component.vue';
import EventBus from '@/utils/event_bus.js';

export default {
  name: 'ChangeState',
  components: {
    formChangeState,
  },
  props: {
    changeStateProps: {
         required: true
      },
    },
 
  data() {
    return {
      visible: false,
    };

  },
  async mounted() {

    EventBus.$on('reload-update-purchaseReconciliation', (name) => {
      this.changeStateProps = name;
      this.closeDialog();
    });
  },

  methods: {
    openDialog(item) {
      this.changeStateProps = item;
      this.visible = true;
    },
  },
}
</script>

<style lang="css" scoped></style>